import 'components/layouts/IRAContributionCard/IRAContributionCard.scss';

import React, { Fragment } from 'react';

import { Dollar } from 'components/shared/Text/Text';
import { CURRENT_YEAR, PRIOR_YEAR } from './Dates';

import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';

export const yearOptions = [
  {
    label: PRIOR_YEAR,
    value: PRIOR_YEAR.toString()
  },
  {
    label: CURRENT_YEAR,
    value: CURRENT_YEAR.toString()
  }
];

export const getPercentChange = (contributionsSoFar, maxLimit) => {
  const percentage = maxLimit > 0 ? (contributionsSoFar / maxLimit) * 100 : 0;
  return percentage > 100 ? 100 : percentage;
};

export const getChartTextProperties = (percentChange) => {
  if (percentChange === 0) {
    return { textX: 45, text: 'Get Started!' };
  }

  if (percentChange > 0 && percentChange <= 60) {
    return { textX: 42, text: 'On your way!' };
  }

  if (percentChange > 60 && percentChange < 100) {
    return { textX: 42, text: 'Almost There!' };
  }

  if (percentChange === 100) {
    return { textX: 45, text: 'Great Job' };
  }

  return { textX: null, text: '' };
};

export const getBodyText = (
  contributionsSoFar,
  hasScheduledContributions = false,
  maximumLimit,
  percentage
) => {
  const difference = maximumLimit - contributionsSoFar;
  if (percentage === 0) {
    return (
      <Fragment>
        Add up to{' '}
        <Dollar className="contribution-card-bold">{maximumLimit}</Dollar> to
        reach your IRS contribution limit.
      </Fragment>
    );
  }

  if (percentage === 100) {
    return hasScheduledContributions ? (
      <Fragment>
        You are scheduled to reach your <Dollar>{maximumLimit}</Dollar> IRS
        contribution limit!
      </Fragment>
    ) : (
      <Fragment>
        You reached your <Dollar>{maximumLimit}</Dollar> IRS contribution limit!
      </Fragment>
    );
  }

  return (
    <Fragment>
      Add <Dollar className="contribution-card-bold">{difference}</Dollar>* to
      max out your <Dollar>{maximumLimit}</Dollar> IRS contribution limit.
    </Fragment>
  );
};

export const hasReceivedMailingAddress = (requestStatus) => {
  return requestStatus.mailingAddress === REQUEST_STATES.received;
};

export const hasReceivedResidentialAddress = (requestStatus) => {
  return requestStatus.residentialAddress && requestStatus.residentialAddress === REQUEST_STATES.received;
};
